import React, { Component } from 'react';
import { Spinner as MySpinner } from "react-bootstrap";

export class Spinner extends Component {
  render() {
    return (
      <div className="spinner-wrapper d-flex justify-content-center align-items-center" style={{minHeight: '15rem', marginTop: '4.7rem'}}>
        <MySpinner animation="grow" size="lg" />
      </div>
    )
  }
}

export default Spinner
